import { Tag, TagColorSchemes, TagSizes } from '@paywithextend/components'
import React, { useState } from 'react'
import HoverTooltip from 'src/components/HoverTooltip/HoverTooltip'
import { css } from 'styled-components'

interface ListeItemToolTipProps {
  className?: string
  tabText: React.ReactElement
  tooltipText: React.ReactElement
  positionBelow?: boolean
}

// Parent element should have a position of relative
const ListItemToolTip: React.FC<ListeItemToolTipProps> = (
  props,
): React.ReactElement => {
  const [show, setShow] = useState(false)
  return (
    <span
      css={css`
        position: relative;
      `}
      onMouseEnter={(): void => setShow(true)}
      onMouseLeave={(): void => setShow(false)}
    >
      <Tag
        text={props.tabText}
        size={TagSizes.XSmall}
        color={TagColorSchemes.Yellow}
      />
      <HoverTooltip show={show} tooltipText={props.tooltipText} />
    </span>
  )
}

export default ListItemToolTip
